<template>
  <div :class="classModifiers">
    <h1 class="visually-hidden">PredictIt — Real-Money Political Prediction Markets</h1>
    <div class="home-old__preview-carousel">
      <preview-carousel></preview-carousel>
    </div>
    <div class="home-old__markets">
      <page-markets
        :headerId="0"
        :embedded="true"
        @embeddedInitialLoadStateChange="onEmbeddedInitialLoadStateChange"
      ></page-markets>
    </div>
  </div>
</template>

<script src="./home-old.js"></script>
<style src="./home-old.scss" lang="scss"></style>
